import React, {useState} from 'react';
import { Form , Button} from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { Alert } from 'react-bootstrap';
import TournoisSuppInscription from './tournoisSuppInscription';

function TournoisModifInscription(props) {
  const [error, setError] = useState(false);
  const [confirmation,setConfirmation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [commentaire, setCommentaire] = useState(props.item.commentaireEquipe)
  const apiUrl = process.env.REACT_APP_API_URL;


  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setConfirmation(false);
    try {
      await axios.patch(`${apiUrl}/tournois/participation/modifier`, {
        commentaire : commentaire,
        idEquipe : props.userData.user.donnée.results[0].id_equipe,
        idTournois : props.item.id_tournoi
      }, {
        withCredentials: true
      });

      setError(null);
      setIsLoading(false);
      window.location.reload(); 

    } catch (error) {
      if (error.response) {
        setIsLoading(false)
        setError(error.response.data.message);
      } else {
        setIsLoading(false)
        setError(true);
      }
    }
  };




  return (
    <>
        {isLoading && 
          <div className="centered-content">
            <img src="/img/logo.png" alt="Logo" className="centered-logo" />
            <br/>
            <span className="loader"></span>
        </div>
    }
    {props.item && (
                        <>
                            {error && <Alert variant="danger">{error}</Alert>}
                            <Form.Label>Votre commentaire (facultatif)</Form.Label>
                            <Form.Control as="textarea" value={commentaire} onChange={(e) => setCommentaire(e.target.value)} placeholder="Ajoutez un commentaire"rows={3} />
                            <br/>
                            <div style={{textAlign:"right"}}>
                                <Button onClick={()=> setConfirmation(true)} variant="secondary" >Modifier</Button>
                            </div>
                            <hr/>   
                            <TournoisSuppInscription item={props.item} userData={props.userData}/>
                        {confirmation && (
                          <>
                            <Modal show={confirmation} onHide={() => {setConfirmation(false)}}>
                                    <Modal.Header closeButton>
                                      <Modal.Title>Participer au tournoi</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        Voulez-vous vraiment confirmer vos modification ?
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button variant="secondary"  onClick={() => {setConfirmation(false)}} >
                                        Quitter
                                      </Button>
                                      <Button variant="primary" onClick={(e) => handleSubmit(e)} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  >
                                        Confirmer
                                      </Button>
                                    </Modal.Footer>
                            </Modal>
                          </>
                        )}
                    </>
            )}

    </>
  );
}

export default TournoisModifInscription;